import './style.css';

import {
  AccessibleContent,
  SideNavBarItem,
  Menu,
  Flex,
  IconExternalLinkLine,
  Text,
  IconArrowDoubleStartLine,
  IconArrowStartLine,
} from '@instructure/ui';
import {
  Badge,
  SideNavBar,
  IconPeerReviewLine,
  IconSettingsLine,
  IconPlusLine,
  IconToggleStartLine,
  IconCalendarMonthLine,
  IconConfigureLine,
} from '@smarterservices/smarter-ui';
import useAppStore from '../../stores/app';
import useSessionStore from '../../stores/session';
import useDataBroker from '../../stores/dataBroker';
import { useEffect, useState } from 'react';
const RoomNavBar = () => {
  const { openDrawer, exitRoom, logout, proctors } = useAppStore();
  const { waiting, reconnect, addRandom } = useSessionStore();
  const { mode } = useDataBroker();

  const [checkinCount, setCheckinCount] = useState(0);

  useEffect(() => {
    setCheckinCount(Object.keys(waiting)?.length + Object.keys(reconnect)?.length);
  }, [waiting, reconnect]);

  const renderCheckinIcon = () => {
    if (checkinCount) {
      return (
        <Badge
          count={checkinCount}
          variant="danger"
          formatOutput={function (formattedCount) {
            return (
              <AccessibleContent
                alt={`${formattedCount} sessions awaiting checkin.`}
              >
                {formattedCount}
              </AccessibleContent>
            );
          }}
        >
          <IconPeerReviewLine />
        </Badge>
      );
    } else {
      return <IconPeerReviewLine />;
    }
  };

  const renderOptionsIcon = () => {
    if (Object.keys(proctors)?.length) {
      return (
        <Badge
          count={Object.keys(proctors).length}
          variant="success"
          formatOutput={function (formattedCount) {
            return (
              <AccessibleContent alt={`${formattedCount} proctors connected`}>
                {formattedCount}
              </AccessibleContent>
            );
          }}
        >
          <IconConfigureLine />
        </Badge>
      );
    } else {
      return <IconConfigureLine />;
    }
  };

  const getNavItems = () => {
    const navItems = [
      <SideNavBarItem
        key="Nav_Checkin"
        label="Checkin"
        icon={renderCheckinIcon()}
        onClick={() => openDrawer('checkin')}
        themeOverride={{
          contentPadding: '1.1em 0',
        }}
      />,

      <SideNavBarItem
        key="Nav_Schedule"
        icon={<IconCalendarMonthLine />}
        label="Schedule"
        onClick={() => openDrawer('schedule')}
        themeOverride={{
          contentPadding: '1.1em 0',
        }}
      />,

      <SideNavBarItem
        key="Nav_Option"
        icon={renderOptionsIcon()}
        label="Options"
        onClick={() => openDrawer('options')}
        themeOverride={{
          contentPadding: '1.1em 0',
        }}
      />,
      <SideNavBarItem
        className="nav-exit"
        key="Nav_Exit"
        style={{ marginTop: 'auto' }}
        icon={<IconArrowDoubleStartLine />}
        label="Exit"
        onClick={() => exitRoom()}
        themeOverride={{
          contentPadding: '1.1em 0',
          marginTop: 'auto',
        }}
      />,

      mode === 'local' && (
        <SideNavBarItem
          key="Nav_Add"
          icon={<IconPlusLine />}
          label="Add"
          onClick={() => addRandom()}
          themeOverride={{
            contentPadding: '1.1em 0',
          }}
        />
      ),
    ].filter(Boolean);

    return navItems;
  };

  return (
    <>
      <SideNavBar
        key="side-bar-nav"
        id="side-bar-nav"
        label="Proctor Room Navigation"
        style={{ flexDirection: 'column', display: 'flex' }}
        toggleLabel={{
          expandedLabel: 'Collapse Navigation',
          minimizedLabel: 'Expand Navigation',
        }}
      >
        {getNavItems()}
      </SideNavBar>
    </>
  );
};

export default RoomNavBar;

/*

  <Menu
          key="Nav_Exit_Menu"
          placement="end"
          shouldContainFocus
          shouldReturnFocus
          mountNode={() => document.body} // Ensures the menu overlays everything
          trigger={
            <SideNavBarItem
              className="nav-exit"
              key="Nav_Exit"
              style={{ marginTop: 'auto' }}
              icon={<IconArrowDoubleStartLine />}
              label="Exit"
              themeOverride={{
                contentPadding: '1.1em 0',
                marginTop: 'auto',
              }}
            />
          }
        >
          <Menu.Item onSelect={() => exitRoom()}>
            <Flex alignItems="center">
              <Flex.Item margin="0 xx-small 0 0">
                <IconToggleStartLine size="x-small" />
              </Flex.Item>
              <Flex.Item>
                <Text>Switch Rooms</Text>
              </Flex.Item>
            </Flex>
          </Menu.Item>
          <Menu.Separator />
          <Menu.Item onSelect={() => logout()}>
            <Flex alignItems="center">
              <Flex.Item margin="0 xx-small 0 0">
                <IconArrowStartLine size="x-small" />
              </Flex.Item>
              <Text>Log Out</Text>
            </Flex>
          </Menu.Item>
        </Menu>

*/
